import { Navigate, useParams } from "react-router-dom";
import { useGetPortalMyBidsQuery } from "../../../autogen/bff-api";
import { urls } from "../../../urls";
import { usePortalEventUrls } from "../portal/usePortalEventUrls";
import { v1BidLinkToV2 } from "./v1BidLinkToV2";

export const LegacyBidLinkRedirect = () => {
  const { bidId } = useParams<{ bidId: string }>();
  const portalUrls = usePortalEventUrls();
  const myBids = useGetPortalMyBidsQuery({});

  if (myBids.isError) return <Navigate to={urls.v2.supplier.bids} replace />;
  if (!myBids.data) return null;

  const bid = myBids.data.bids.find((candidate) => candidate.bidId === bidId);
  return <Navigate to={bid ? v1BidLinkToV2(portalUrls, bid) : urls.v2.supplier.bids} replace />;
};
